<img [src]="imageSrc" />
